import { Output } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { Input } from '@angular/core';
import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-modal-confirmar-cerrar-session',
    templateUrl: './modal-confirmar-cerrar-session.component.html',
    styleUrls: ['./modal-confirmar-cerrar-session.component.css'],
    standalone: false
})
export class ModalConfirmarCerrarSessionComponent implements OnInit {
  @Input() classModal;
  @Input() title: string = '';
  @Input() message: string = '';
  @Output() enventoCerrarModalPadre = new EventEmitter<void>();
  @Output() enventoCerrarSessionPadre = new EventEmitter<void>();
  isVisible: boolean = false;

  constructor() { }

  ngOnInit(): void {
  }
  eventoCerrarModal() {
    this.enventoCerrarModalPadre.emit();
  }
  eventoCerrarSession() {
    this.enventoCerrarSessionPadre.emit();
  }
  open() {
    this.isVisible = true;
  }

  close() {
    this.isVisible = false;
  }
}


